<template>
  <div class="content-model-view swiper-no-swiping">
    <div class="embedded-loader" ref="loader">
      <div class="spinner"></div>
    </div>
    <model-viewer
      ref="modelViewer"
      :src="src"
      class="content-model-view swiper-no-swiping"
      loading="eager"
      auto-rotate-delay="0"
      camera-controls
      auto-rotate
      interaction-prompt="none"
    ></model-viewer>
  </div>
</template>

<script>
export default {
  props: {
    src: String,
  },
  data() {
    return {};
  },
  mounted: function () {
    this.$refs.modelViewer.addEventListener("load", this.loaded);
  },
  methods: {
    loaded: function (e) {
      this.$refs.loader.style.display = "none";
    },
  },
};
</script>

<style scoped></style>
